import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=1e1fb11e&scoped=true"
import script from "./NewLayout.vue?vue&type=script&lang=js"
export * from "./NewLayout.vue?vue&type=script&lang=js"
import style0 from "./NewLayout.vue?vue&type=style&index=0&id=1e1fb11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1fb11e",
  null
  
)

export default component.exports